export const getDonations = (state) => state.donation.donations;
export const getDonationsWithMessage = (state) => state.donation.donations.filter((donation) => !!donation.message);
